// Shared helpers for the Knowledge surfaces (library + data pages).
import type { KnowledgeFieldSchema, KnowledgeSource } from './types';

// A person has no page here, so only a connected source or a document links anywhere.
export const sourceHref = (s: KnowledgeSource): string | null =>
    s.kind === 'source' ? `/sources/${s.id}` : s.kind === 'document' ? `/files/${s.id}` : null;

// Node colour is a stable hash of the label, so a label keeps its colour everywhere with no config.
const LABEL_COLORS = [
    '#2563eb', '#059669', '#d97706', '#dc2626', '#7c3aed', '#0891b2',
    '#c026d3', '#65a30d', '#ea580c', '#4f46e5', '#0d9488', '#be123c',
];

export function labelColor(label?: string): string {
    if (!label) return '#5E6E73';
    let h = 0;
    for (let i = 0; i < label.length; i++) h = (h * 31 + label.charCodeAt(i)) | 0;
    return LABEL_COLORS[Math.abs(h) % LABEL_COLORS.length];
}

export const labelText = (l: string) =>
    (l.charAt(0).toUpperCase() + l.slice(1)).replace(/_/g, ' ');

export function fieldType(s: KnowledgeFieldSchema): string {
    if (s.$ref) return s.$ref.split('/').pop() || 'object';
    if (s.enum) return `enum: ${s.enum.join(' | ')}`;
    const t = s.type ?? 'any';
    return s.format ? `${t} (${s.format})` : t;
}

export function renderValue(v: any): string {
    if (v === null || v === undefined || v === '') return '—';
    if (typeof v === 'object') {
        if (typeof v.amount === 'number' && typeof v.currency === 'string') {
            return `${v.amount.toLocaleString()} ${v.currency}`;
        }
        return JSON.stringify(v);
    }
    return String(v);
}
